import { memo, useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Skeleton } from 'root/src/client/v2/common/components/ui/skeleton';
import { RedesignDropCard } from 'root/src/client/v2/_pages/drops/redesign/RedesignDropCard';
// The base `grid-cols-1` is load-bearing, not decoration: without it the mobile grid falls back to one
// implicit `auto` column, whose minimum is min-content. Card content that sets `white-space: nowrap`
// (any `truncate`, e.g. the genres line) then reports its full text width as min-content and pushes the
// column past the viewport. `grid-cols-1` resolves to minmax(0, 1fr), which lets the column shrink.
const GridSkeleton = () => (<div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
		{Array.from({ length: 6 }).map((_, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <div key={index} className="overflow-hidden rounded-xl border border-solid border-white/[0.06] bg-card">
				<Skeleton className="aspect-video w-full rounded-none"/>
				<div className="space-y-3 p-5">
					<Skeleton className="h-4 w-24"/>
					<Skeleton className="h-5 w-40"/>
					<Skeleton className="h-9 w-full rounded-lg"/>
				</div>
			</div>))}
	</div>);
export const DropsGrid = memo(({ drops, status, isLoading, search }) => {
    const filtered = useMemo(() => {
        const query = search.trim().toLowerCase();
        if (!query) {
            return drops;
        }
        return drops.filter(drop => drop.label.toLowerCase().includes(query));
    }, [drops, search]);
    if (isLoading) {
        return <GridSkeleton />;
    }
    if (!filtered.length) {
        return (<div className="mt-12 text-center">
				<p className="text-muted-foreground">
					{search.trim() ? 'No drops found matching your search.' : 'No drops available here yet.'}
				</p>
			</div>);
    }
    return (<motion.div layout data-onboarding="drops-grid" className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
			<AnimatePresence mode="popLayout">
				{filtered.map((drop, index) => (<RedesignDropCard key={drop.id} drop={drop} status={status} index={index}/>))}
			</AnimatePresence>
		</motion.div>);
});
